<template lang="pug">
#autocomplete-group
  v-autocomplete(
    v-model="group_filter",
    :items="group_options",
    :get-label='getLabel',
    :component-item='template',
    :input-attrs='attrs',
    :auto-select-one-item='false',
    v-on-clickaway='onClickaway',
    @update-items="updateGroups",
    class="no-border",
    @item-selected='selected'
  )
  span.gray-bold-caret
</template>

<script>
const listItem = require('./group_item.vue')
const helpers = require('../../../helpers.coffee')
const on_clickaway = require('vue-clickaway')

const view_model = {
  mixins: [ on_clickaway.mixin ],
  props: ['user_id'],
  data() {
    return {
      group_options: [],
      template: listItem,
      group_filter: null,
      attrs: {
        placeholder: "Grupo"
      }
    }
  },

  watch: {
    user_id () {
      this.loadGroups()
    }
  },

  methods: {
    onClickaway() {
      this.$emit('hide')
    },

    getLabel(group) {
      return (group != null ? group.name : undefined)
    },

    updateGroups(text) {
      let params = { page: 1, per: 10, q: {search_query: text, s: 'name asc'} }
      this.contact_groups_resource.index(this.loadGroupsSuccess, this.unknownError, {params: params})
    },

    selected (item) {
      this.$emit('group-selected', item)
    },

    loadGroups() {
      let params = { page: 1, per: 10, q: {s: 'name asc'} }
      if (this.user_id) params.q.user_id_eq = this.user_id
      this.contact_groups_resource.index(this.loadGroupsSuccess, null, {params: params})
    },

    loadGroupsSuccess (data) {
      this.group_options = data.contact_groups
      this.group_options.unshift({id: null, name: 'Grupos'})
    }
  },

  mounted() {
    this.contact_groups_resource = new ContactGroupsResource(Session.current_company.id)
    this.loadGroups()
  }
}
exports.default = helpers.vue_include(view_model, helpers.filters)

</script>

<style lang="sass">
  @import '../../../assets/stylesheets/_variables.sass'
  #autocomplete-group
    display: inline-grid
    max-width: 150px
    padding: 0 10px
    height: 40px

    .gray-bold-caret
      position: relative
      left: 100px
      bottom: 22px

    .v-autocomplete
      .v-autocomplete-input-group
        .v-autocomplete-input
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          border-radius: 0px
          padding 10px 15px
          box-shadow none
          font-size: 11px
          color: #7b8e9e !important
          height: 33px
          padding-left: 10px;
        &.v-autocomplete-selected
          .v-autocomplete-input
      .v-autocomplete-list
        width: 100%
        border: none
        z-index: 9999
        .v-autocomplete-list-item
          padding-left: 10px
          background-color: white
          width: 100%
          position: relative
          cursor: pointer
          height: 30px
          line-height: 30px !important
          font-size: 10px
          z-index: 9999
          color: #7b8e9e
          font-size: 11px
  
</style>



// WEBPACK FOOTER //
// group.vue?402d806c